import { render, staticRenderFns } from "./recepcionpaquete.vue?vue&type=template&id=89eec222"
import script from "./recepcionpaquete.vue?vue&type=script&lang=js"
export * from "./recepcionpaquete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports